module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.2e250873.woff";